module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('loading-icon', {
    staticClass: "c-card"
  }) : _c('div', {
    staticClass: "c-card c-card--quizzes"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__title t-headline"
  }, [_vm._v(_vm._s(_vm.card.title))])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__body"
  }, [(_vm.quizzesUntaken.length) ? [_c('ol', {
    staticClass: "c-card--quizzes__untaken-list"
  }, _vm._l((_vm.quizzesUntaken), function(quiz, i) {
    return _c('li', [_c('div', {
      staticClass: "c-card--quizzes__untaken-list__single qa-open-modal-button",
      on: {
        "click": function($event) {
          return _vm.showModal(quiz.code)
        }
      }
    }, [_vm._v("\n            " + _vm._s(quiz.name) + "\n            "), _c('i', {
      staticClass: "fa fa-arrow-right c-card--quizzes__untaken-list__single__icon\n              t-icon",
      attrs: {
        "aria-hidden": "true"
      }
    })])])
  }), 0)] : _vm._e(), _vm._v(" "), (!_vm.quizzesUntaken.length) ? [_c('div', {
    staticClass: "c-card--quizzes__untaken-empty"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-up c-card--quizzes__untaken-empty__icon t-icon"
  }), _vm._v(" "), _c('p', {
    staticClass: "c-card--quizzes__untaken-empty__text"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.card_quizzes.no_quizzes_available')) + "\n        ")])])] : _vm._e(), _vm._v(" "), (_vm.quizzesTaken.length) ? [_c('h3', {
    staticClass: "c-card--quizzes__taken-header qa-heading-taken"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('web.card_quizzes.completed_quizzes')) + "\n      ")]), _vm._v(" "), _c('ol', {
    staticClass: "c-card--quizzes__taken-list"
  }, _vm._l((_vm.quizzesTaken), function(quiz, i) {
    return _c('li', [_c('button', {
      staticClass: "c-card--quizzes__taken-list__single qa-open-modal-button-disabled",
      attrs: {
        "disabled": ""
      }
    }, [_vm._v("\n            " + _vm._s(quiz.name) + "\n          ")])])
  }), 0)] : _vm._e()], 2), _vm._v(" "), _c('portal', {
    attrs: {
      "to": "modal"
    }
  }, _vm._l((_vm.quizzes), function(quiz) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.modalIsVisible(quiz.code)),
        expression: "modalIsVisible(quiz.code)"
      }],
      key: quiz.code,
      staticClass: "c-modal c-modal--quiz"
    }, [_c('section', {
      staticClass: "c-modal__box c-modal--quiz__box"
    }, [_c('div', {
      staticClass: "c-modal__box__header t-modal-header"
    }, [_c('h2', {
      staticClass: "c-modal__box__header__title t-modal-header__text"
    }, [_vm._v("\n            " + _vm._s(quiz.name) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "c-modal__box__header__close"
    }, [_c('button', {
      staticClass: "c-modal__box__header__close__button\n                        t-modal-header__close\n                        qa-close-modal-button",
      on: {
        "click": _vm.hideModal
      }
    }, [_c('i', {
      staticClass: "fa fa-close"
    })])])]), _vm._v(" "), _c('div', {
      ref: quiz.code + '-quiz',
      refInFor: true,
      staticClass: "c-modal--quiz__wrapper__quiz"
    })]), _vm._v(" "), _c('div', {
      staticClass: "c-modal__overlay"
    })])
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-431ef704"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/cards/Quizzes.vue
// module id = 530
// module chunks = 1